import styled from "styled-components";

export const BoxBody = styled.div`
    width: 100%;
    height: 100vh;
    background: #095AA5;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const BoxContainerLogin = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 30px;

    @media (max-width: 800px) {
      flex-direction: column;
    }

    div.logo {
      width: 50%;

      img {
        max-width: 100%;
      }

      h1 {
        color: #FFF;
        font-family: 'Poppins';
        font-size: 60px;
        margin: 0;
        padding: 0;
        text-align: center;

        @media (max-width: 800px) {
          font-size: 20px;
        }
      }
    }


    div.form {
      width: 50%;

      input {
        width: 100%;
      }
    }
`;
